const getErrorMessage = (error) => {
	if (error.response) {
		let { data: { message } } = error.response;
		if (Array.isArray(message)) {
			message = message.join("\n");
		}
		return message;
	} else if (error.message) {
		return error.message;
	} else if (typeof error === "string") {
		return error;
	}
	return "an unknown error occurred";
};

export default getErrorMessage;
